import styled from 'styled-components';
import { BLACK, PRIMARY } from '../../utils/colors';
import device from '../../utils/mediaQuery';

export const Page = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  z-index: 1000;
`;

export const Nav = styled.nav`
  width: 100%;
  display: flex;
  align-items: center;
  padding: 24px;
  flex-shrink: 0;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  text-align: center;
  margin-top: -60px;
`;

export const Heading = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: ${BLACK};
  margin-top: 20px;
  text-align: center;

  @media ${device.small} {
    font-size: 28px;
  }
`;

export const SubText = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: rgba(13, 13, 13, 0.6);
  margin-top: 8px;
`;

export const IconWrapper = styled.div`
  width: 245px;
  height: 245px;
  margin: 0 auto;

  @media ${device.medium} {
    width: 200px;
    height: 200px;
  }
`;

export const BackButton = styled.button`
  background: ${PRIMARY};
  color: white;
  border: none;
  border-radius: 82px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;
